// erp 接口
export default {
  $getway: 'OurwayErp',
  doAudit: 'Bill/doAudit', // 审核
  doBlankOut: 'Bill/doBlankOut', // 作废
  doCancleAudit: 'Bill/doCancleAudit', // 退审
  doFinish: 'Bill/doFinish', // 完成
  getBillId: 'Bill/getBillId', // 获取单据编号信息，新增时调用
  getCheckChecking: 'Bill/getCheckChecking', // 获取单据审核信息
  getCheckProcess: 'Bill/getCheckProcess', // 获取单据审核流程信息，窗体加载时获取
  annexDetail: 'Annex/detail', // 单据的附件详情查询,无分页
  annexDownload: 'Annex/download', // 单条附件下载
  annexSearch: 'Annex/search', // 单据的附件详情查询,带分页
  annexUpload: 'Annex/upload', // 单条附件上传
  annexRemove: 'Annex/remove', // 单条附件删除
  save: 'dataDictMainController/save', // 数据字典保存
};
